
const REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;
gsap.registerPlugin(ScrollTrigger);
history.scrollRestoration = 'manual';
window.scrollTo(0, 0);
function goTo(top, opts){ if (opts && opts.immediate){ window.scrollTo(0, top); } else { window.scrollTo({ top, behavior: 'smooth' }); } }
/* drawer móvil */
const drawer = document.getElementById('drawer');
document.getElementById('burger').addEventListener('click', () => {
  drawer.classList.add('open');
  if (!REDUCE) gsap.fromTo('.drawer a', { x: 40, opacity: 0 }, { x: 0, opacity: 1, stagger: .06, duration: .5, ease: 'power3.out' });
});
document.getElementById('drawerClose').addEventListener('click', () => drawer.classList.remove('open'));
/* molécula 3D — solo tiempo, independiente del scroll */
try{(function(){
  const holder = document.getElementById('mol');
  const scene = new THREE.Scene();
  scene.fog = new THREE.Fog(0x1B2A4C, 14, 38);
  const cam = new THREE.PerspectiveCamera(55, innerWidth/innerHeight, .1, 100); cam.position.z = 20;
  const ren = new THREE.WebGLRenderer({ antialias: false, alpha: true });
  ren.setSize(innerWidth, innerHeight); ren.setPixelRatio(1);
  holder.appendChild(ren.domElement);
  const group = new THREE.Group(); scene.add(group);
  const nodeGeo = new THREE.SphereGeometry(.09, 12, 12);
  const matBase = new THREE.MeshBasicMaterial({ color: 0xF2EDE2, transparent: true, opacity: .8 });
  const matCoral = new THREE.MeshBasicMaterial({ color: 0xDC6E62 });
  const matCobre = new THREE.MeshBasicMaterial({ color: 0xE3B187 });
  const lineMat = new THREE.LineBasicMaterial({ color: 0xF2EDE2, transparent: true, opacity: .22 });
  const lineMatC = new THREE.LineBasicMaterial({ color: 0xC98E5F, transparent: true, opacity: .55 });
  function hexRing(cx, cy, cz, r, tx, ty, hot){
    const pts = [];
    for (let i = 0; i < 6; i++){ const a = i/6*Math.PI*2; pts.push(new THREE.Vector3(cx+Math.cos(a)*r, cy+Math.sin(a)*r, cz)); }
    const ring = new THREE.Group();
    pts.forEach((p, i) => {
      const m = (hot && i%3===0) ? (Math.random()>.5?matCoral:matCobre) : matBase;
      const s = new THREE.Mesh(nodeGeo, m); s.position.copy(p);
      s.userData.base = p.clone(); s.userData.ph = Math.random()*Math.PI*2; ring.add(s);
      ring.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints([p, pts[(i+1)%6]]), (hot&&i%2===0)?lineMatC:lineMat));
    });
    ring.rotation.x = tx; ring.rotation.y = ty; group.add(ring);
  }
  let seed = 7; const rnd = () => { seed = (seed*16807)%2147483647; return (seed-1)/2147483646; };
  for (let i = 0; i < 16; i++) hexRing((rnd()-.5)*26, (rnd()-.5)*15, (rnd()-.5)*14-2, 1+rnd()*1.6, rnd()*Math.PI, rnd()*Math.PI, rnd()>.55);
  const clock = new THREE.Clock();
  window.__molOn = true;
  (function loop(){
    requestAnimationFrame(loop);
    if (!window.__molOn) return;
    const t = clock.getElapsedTime();
    if (!REDUCE){
      group.rotation.y = t * .045;
      group.rotation.x = Math.sin(t * .12) * .08;
      group.children.forEach(ring => ring.children.forEach(ch => { if (ch.isMesh) ch.position.y = ch.userData.base.y + Math.sin(t*.8+ch.userData.ph)*.12; }));
    }
    ren.render(scene, cam);
  })();
  addEventListener('resize', () => { cam.aspect = innerWidth/innerHeight; cam.updateProjectionMatrix(); ren.setSize(innerWidth, innerHeight); });
})();}catch(e){ var m = document.getElementById('mol'); if (m) m.style.display = 'none'; }
/* entrada hero — CSS puro (no depende del ticker de gsap, nunca deja el hero invisible) */
(function(){
  if (!REDUCE){
    var css = '@keyframes vnUp{from{transform:translateY(115%)}to{transform:translateY(0)}}'
      + '@keyframes vnFadeUp{from{opacity:0;transform:translateY(28px)}to{opacity:1;transform:translateY(0)}}'
      + '@keyframes vnFade{from{opacity:0}to{opacity:1}}'
      + 'html.loaded #masthead .line span{animation:vnUp 1s cubic-bezier(.16,1,.3,1) both}'
      + 'html.loaded #masthead .line:nth-child(2) span{animation-delay:.12s}'
      + 'html.loaded .bote{animation:vnFadeUp 1.05s cubic-bezier(.16,1,.3,1) .4s both}'
      + 'html.loaded .hero-sub{animation:vnFadeUp .85s ease .62s both}'
      + 'html.loaded .hero-cta{animation:vnFadeUp .85s ease .74s both}'
      + 'html.loaded .tag{animation:vnFade .9s ease .85s both}';
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  }
  function go(){ document.documentElement.classList.add('loaded'); }
  if (document.readyState !== 'loading') go(); else addEventListener('DOMContentLoaded', go);
})();
try{ gsap.ticker.lagSmoothing(0); }catch(e){}
/* canvas solo visible mientras el hero está en pantalla */
ScrollTrigger.create({ trigger: '.hero', start: 'top bottom', end: 'bottom top',
  onToggle: s => { window.__molOn = s.isActive; const m = document.getElementById('mol'); if (m) m.style.visibility = s.isActive ? 'visible' : 'hidden'; } });
/* sombra header */
ScrollTrigger.create({ start: 40, end: 'max', onToggle: s => document.querySelector('nav').classList.toggle('scrolled', s.isActive) });
/* beneficios: scroll + flechas + arrastre */
const track = document.getElementById('track');
function trackX(){ return -(track.scrollWidth - innerWidth + innerWidth*.06); }
const beneTween = gsap.to(track, { x: trackX, ease: 'none',
  scrollTrigger: { trigger: '.bene-wrap', start: 'top top', end: 'bottom bottom', scrub: REDUCE ? false : .4, invalidateOnRefresh: true } });
const bst = beneTween.scrollTrigger;
function beneJump(dir){
  const cards = track.children;
  const stepX = cards[1].offsetLeft - cards[0].offsetLeft;
  const len = bst.end - bst.start;
  const cur = bst.start + bst.progress*len;
  const target = Math.max(bst.start, Math.min(bst.end, cur + dir * (stepX / -trackX()) * len));
  goTo(target, { duration: .8 });
}
document.getElementById('bNext').addEventListener('click', () => beneJump(1));
document.getElementById('bPrev').addEventListener('click', () => beneJump(-1));
let dragging = false, lastX = 0;
track.addEventListener('pointerdown', e => { dragging = true; lastX = e.clientX; });
addEventListener('pointermove', e => {
  if (!dragging) return;
  const dx = e.clientX - lastX; lastX = e.clientX;
  const len = bst.end - bst.start;
  const target = Math.max(bst.start, Math.min(bst.end, window.scrollY - dx * (len / -trackX())));
  goTo(target, { immediate: true });
});
addEventListener('pointerup', () => dragging = false);
/* bundle réplica live: radio selector */
const bunOpts = gsap.utils.toArray('.vn-bun__opt');
bunOpts.forEach(o => o.addEventListener('click', () => {
  bunOpts.forEach(x => x.setAttribute('data-selected','false'));
  o.setAttribute('data-selected','true');
}));
/* cómo funciona */
if(document.querySelector('.lab')){
const steps = gsap.utils.toArray('.lab-step');
const snavs = gsap.utils.toArray('.snav');
const SEG = .21;
const labTl = gsap.timeline({ scrollTrigger: { trigger: '.lab', start: 'top top', end: 'bottom bottom', scrub: REDUCE ? false : .5,
  onUpdate: s => {
    const pr = Math.min(s.progress, SEG*4 - .001);
    const seg = Math.min(3, Math.floor(pr/SEG));
    const segP = (pr - seg*SEG)/SEG;
    snavs.forEach((el, i) => {
      el.classList.toggle('on', i === seg);
      el.querySelector('.bar i').style.width = (i === seg ? segP*100 : (i < seg ? 100 : 0)) + '%';
    });
  }}});
steps.forEach((st, i) => {
  if (i > 0) labTl.fromTo(st, { autoAlpha: 0, y: 24 }, { autoAlpha: 1, y: 0, duration: .08, ease: 'power2.out' }, i*SEG+.02);
  if (i < 3) labTl.to(st, { autoAlpha: 0, y: -20, duration: .07, ease: 'power2.in' }, i*SEG+.14);
});
labTl.to('.lab-pin', { autoAlpha: 0, duration: .05, ease: 'none' }, .94);
const labEl = document.querySelector('.lab');
snavs.forEach(el => el.addEventListener('click', () => {
  const i = +el.dataset.i;
  goTo(labEl.offsetTop + (labEl.offsetHeight - innerHeight) * (i*SEG + .05), { duration: 1 });
}));
}
/* reseña palabra a palabra */
const q = document.getElementById('quoteTxt');
q.innerHTML = q.textContent.split(' ').map(w => `<span class="w">${w}</span>`).join(' ');
const ws = q.querySelectorAll('.w');
ScrollTrigger.create({ trigger: '.res-quote', start: 'top 80%', end: 'top 25%', scrub: true,
  onUpdate: s => { const n = Math.floor(s.progress*ws.length); ws.forEach((w, i) => w.classList.toggle('on', i <= n)); } });
/* reveals */
gsap.utils.toArray('.rcard, .faq details, .res-grid, .faq h2, .vn-bun__head, .vn-bun__grid, .vn-bun__buy').forEach(el => {
  gsap.from(el, { y: REDUCE ? 0 : 30, opacity: REDUCE ? 1 : 0, duration: .8, ease: 'power3.out',
    scrollTrigger: { trigger: el, start: 'top 92%' } });
});


/* Sección liposomal: reveal por scroll — independiente de GSAP */
(function(){
  function run(){
    var els=document.querySelectorAll('.liq-rev'); if(!els.length) return;
    if(!('IntersectionObserver' in window)){return;}
    document.documentElement.classList.add('js-liq');
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in'); io.unobserve(x.target);}});},{threshold:.18, rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e);});
  }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
